import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../../app/freightconfirmation/app.sharemodule";
import { LayoutModule } from "../../../app/theme/layouts/layout.module";
import { RouterModule, Routes } from "@angular/router";
import { OnflyNetworkModule } from "../../../app/Network/onfly-network/onfly-network.module";
import { BookingDashboardComponent } from "./booking-dashboard.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxBarcodeModule } from "ngx-barcode";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { DefaultComponent } from "../../../app/theme/pages/default/default.component";
import { TranslateModule } from "@ngx-translate/core";

const routes: Routes = [
  {
    path: "",
    component: DefaultComponent,
    children: [
      {
        path: "",
        component: DashboardComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormsModule,
    SharedModule,
    LayoutModule,
    RouterModule,
    NgxBarcodeModule,
  ],
  declarations: [BookingDashboardComponent],
  exports: [BookingDashboardComponent],
})
export class BookingDashboardModule {}
